import { render, staticRenderFns } from "./UploadDetail.vue?vue&type=template&id=9db174f4&scoped=true"
import script from "./UploadDetail.vue?vue&type=script&lang=js"
export * from "./UploadDetail.vue?vue&type=script&lang=js"
import style0 from "./UploadDetail.vue?vue&type=style&index=0&id=9db174f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db174f4",
  null
  
)

export default component.exports